import * as Sentry from "@sentry/react";

if (process.env.REACT_APP_ENV !== "development") {
  Sentry.init({
    dsn: "https://61b5b8d844afb6772aec14d144c4fb7c@o4507898861649920.ingest.us.sentry.io/4507898863681536",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [/^https:\/\/(test-)?guest\.avendi\.me/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    environment: process.env.REACT_APP_ENV,
  });
}
